<template>
    <div class="contain" ref="container">
        <div class="section01" ref="section01">
            <img class="imgs" src="../../../assets/c23/guide01.png" alt="다이어트 병원 방문 진료 OPEN (다음 내용 참조)" />
            <!-- <span class="btn-section-mouse" ref="buttonMouse">
                <img class="section-mouse" src="../../../assets/c23/img_mouse_arrow.png" alt="" />
            </span> -->

            <span class="btn-section-mouse" ref="buttonMouse">
                <img class="section-mouse" src="../../../assets/c23/img_mouse_arrow.png" alt="">
                <img class="mouse-arrow" src="../../../assets/c23/img_chevron_down.png" alt="">
            </span>
        </div>
        <img class="imgs" src="../../../assets/c23/guide02.png" alt="다이어트 병원 방문 진료 OPEN (다음 내용 참조)" ref="secondImage" />
        <img class="imgs" src="../../../assets/c23/guide03.png" alt="다이어트 병원 방문 진료 OPEN (다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c23/guide04.png" alt="다이어트 병원 방문 진료 OPEN (다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c23/guide05.png" alt="다이어트 병원 방문 진료 OPEN (다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c23/guide06.png" alt="다이어트 병원 방문 진료 OPEN (다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c23/guide07.png" alt="다이어트 병원 방문 진료 OPEN (다음 내용 참조)" />
        <img class="imgs" src="../../../assets/c23/guide08.png" alt="다이어트 병원 방문 진료 OPEN (다음 내용 참조)" />
        <img class="imgs last-imgs" src="../../../assets/c23/guide09.png" alt="다이어트 병원 방문 진료 OPEN (다음 내용 참조)" />
        
        <div class="sr-only">
            <h1>다이어트 병원 방문 진료 OPEN</h1>
            <h2>재고 걱정 NO 솔닥에는 다 있습니다</h2>
            <p>솔닥에서 다이어트 주사 재고 보유 정보는 물론 위치, 가격까지 모두 확인하고 예약하세요</p>
            <ul>
                <li>
                    <h3>
                        <strong>다이어트진료 POINT 1</strong>
                        <span>가격은 물론, 전부 꼼꼼히 따져보고 선택하세요</span>
                    </h3>
                    <p>병원 위치, 가격, 의사선생님, 진료과목 등 충분히 따져보고 선택하세요</p>
                    <p>* 예시 화면입니다. 병원별 진료비 등 가격 정보는 진료 예약 시 병원 상세페이지를 확인해 주세요.</p>
                </li>
                <li>
                    <h3>
                        <strong>다이어트진료 POINT 2</strong>
                        <span>후속 진료는 비대면진료도 OK</span>
                    </h3>
                    <p>추후 추가 진료가 필요하다면 대면/비대면진료 모두 이용 가능해요</p>
                </li>
                <li>
                    <h3>
                        <strong>다이어트진료 POINT 3</strong>
                        <span>솔닥 이용 수수료는 0원</span>
                    </h3>
                    <p>솔닥을 통한 예약으로 발생하는 별도의 추가 수수료는 없습니다</p>
                    <p>* 예시 화면입니다. 병원별 진료비 등 가격 정보는 진료 예약 시 병원 상세페이지를 확인해 주세요.</p>
                </li>
            </ul>
            <h2>이용 방법</h2>
            <ul>
                <li>STEP 01 진료 선택
                    <ol>
                        <li>1. 병원 방문진료</li>
                        <li>2. 다이어트 주사 선택</li>
                    </ol>
                </li>
                <li>STEP 02 병원 선택
                    <p>솔닥 모든 제휴 기관 재고 100% 확보</p>
                </li>
                <li>STEP 03 앱으로 진료 예약</li>
                <li>STEP 04 바로 픽업
                    <p>* 진료 후 바로 수령 가능합니다.</p>
                </li>
            </ul>
            <h2>지금 바로 재고 보유 기관 목록을 확인하세요</h2>
            <h2>FAQ</h2>
            <div>
                <dl>
                    <dt><strong><span>Q1</span>비대면진료도 이용 가능한가요?</strong></dt>
                    <dd>
                        <p><span>A1</span> 다이어트 주사 처방은 대면/비대면 모두 가능하지만, 재고 확인하기 서비스는 병원 방문 시 이용할 수 있는 서비스입니다. 비대면진료 이용 시 다이어트 주사제 약국 수령을 위해 재고와 비용을 별도 확인해 주셔야 합니다.</p>
                    </dd>
                </dl>
                <dl>
                    <dt><strong><span>Q2</span>다이어트 주사 가격은 어떻게 되나요?</strong></dt>
                    <dd>
                        <p><span>A2</span>진료비 등 각종 비용은 병원별 상세페이지에서 확인 가능합니다.</p>
                    </dd>
                </dl>
                <dl>
                    <dt><strong><span>Q3</span>처방받은 주사는 어떻게 수령해야 하나요?</strong></dt>
                    <dd>
                        <p><span>A3</span>솔닥 예약 후 방문하시면 원내 수령 및 약국 수령 모두 가능합니다. *약국 수령의 경우 재고 및 비용 별도 확인 필요</p>
                    </dd>
                </dl>
                <dl>
                    <dt><strong><span>Q3</span>비용 결제는 어떻게 하나요?</strong></dt>
                    <dd>
                        <p><span>A3</span>앱내 원클릭 결제 또는 원내 결제 모두 가능합니다.</p>
                    </dd>
                </dl>
                <dl>
                    <dt><strong><span>Q4</span>솔닥 수수료는 없나요?</strong></dt>
                    <dd>
                        <p><span>A4</span>솔닥을 통해 예약하더라도 발생하는 수수료는 0원입니다.</p>
                    </dd>
                </dl>
            </div>
        </div>
        <a href="https://soldoc.ap2.dfn.link/api/v1/click/FL2CP7ka8US3rsW9tJw9QA?deeplink_custom_path=soldoc://home/search?departmentId=24?serviceType=CONTACT?type=DEPARTMENT?isEntireRegion=true&abx_tracker_id=FL2CP7ka8US3rsW9tJw9QA" 
            target="_blank" title="새 창" :class="['c23-floot-cta', { scrolled: isScrolled }]">
            <img class="imgs" src="../../../assets/c23/cta-btn.png" alt="재고 보유처 목록 확인하기 (솔닥 모든 제휴 의료기관, 재고 100% 확보)" />
        </a>
    </div>
</template>

<script>
export default {
    name: "c23",
    data() {
        return {
            isScrolled: false,
        };
    },
    methods: {
        handleScroll() {
            const secondImage = this.$refs.secondImage;
            const rect = secondImage.getBoundingClientRect();
            this.isScrolled = rect.top <= window.innerHeight - 410;

            const section = this.$refs.section01;
            if (section) {
                const sectionBottom = section.getBoundingClientRect().bottom;
                const windowHeight = window.innerHeight;
                if (sectionBottom < windowHeight - 90) {
                    this.$refs.buttonMouse.classList.add("active");
                } else {
                    this.$refs.buttonMouse.classList.remove("active");
                }
            }
        },
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener("resize", this.handleScroll); // 창 크기 변경에도 반응
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.handleScroll);
    },
};
</script>

<style scoped>
    .contain {
        width: 100%;
        max-width: 800px;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        margin: 0 auto;
        overflow: hidden;
    }
    .contain .imgs {
        width: 100%;
    }
    .contain .last-imgs {
        margin-bottom: 130px;
    }
    .contain .sr-only {
        position: absolute;
        left: -9999px;
        width: 1px;
        height: 1px;
        margin: 0 !important;
        font-size: 0;
        line-height: 0;
        overflow: hidden;
    }
    .c23-floot-cta {
        position: fixed;
        bottom: 30px;
        max-width: 800px;
        width: 100%;
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.5s ease;
    }
    .c23-floot-cta .imgs {
        width: 100%;
        padding: 0 5%;
    }
    .c23-floot-cta.scrolled {
        visibility: visible;
        opacity: 1;
    }
    .section01 {
        position: relative;
        display: block;
        width: 100%;
        overflow: hidden;
    }
    .btn-section-mouse {
        position: fixed;
        left: 50%;
        bottom: 30px;
        /* bottom: 1.875%; */
        transform: translate(-50%);
        display: flex;
        flex-direction: column;
        max-width: 47px;
        width: 5.8%;
        /* height: 7.625rem; */
        margin: 0;
        padding: 0;
        background: none;
        border: none;
        z-index: 20;
    }
    .btn-section-mouse.active {
        position: absolute;
        bottom: 30px;
    }
    .btn-section-mouse > img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .section-mouse{
        position: relative;
        display: block;
    }
    .mouse-arrow{
        display: block;
        transform-origin: 0px 0px;
        transform: translate(0, 0);
        animation: scroll-down 900ms ease-in-out infinite;
    }

    @keyframes scroll-down {
        0% {
        transform: translate(0, 3px);
        }
        30% {
        transform: translate(0, -2px);
        }       
        45% {
        transform: translate(0, 3px);
        }
        100% {
        transform: translate(0, 3px);
        }
    }

    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/pc_view/contents/c23.vue